export const X_TBA_AUTH_KEY = 'LuZ6vmMGf9rDpZfXvo67urtAeNODH4rHU2a2mJ5HoGApBxA1tNOmEr4vBccYjmDJ';

export const FIREBASE_CONFIG = {
    apiKey: 'AIzaSyDt7ruHB7j5VgCFtONBAqnBh1Q-k2NjN8Y',
    authDomain: 'falconscoutapp.firebaseapp.com',
    databaseURL: 'https://falconscoutapp.firebaseio.com',
    projectId: 'falconscoutapp',
    storageBucket: 'falconscoutapp.appspot.com',
    messagingSenderId: '1040377302545'
};